export function replaceNullValuesWithEmptyString<Type>(object: Type): Type {
	if (object === null) {
		return {} as Type;
	}

	type ObjectType = Record<string, unknown>;

	if (typeof object === "object" && object !== null) {
		const result = Array.isArray(object) ? [...object] : { ...object };

		for (const key in result as ObjectType) {
			const value = (result as ObjectType)[key];
			if (value === null) {
				(result as ObjectType)[key] = "";
			} else if (typeof value === "object" && value !== null) {
				(result as ObjectType)[key] = replaceNullValuesWithEmptyString(value);
			}
		}

		return result as Type;
	}

	return object;
}
